var map = {
	"./air-conditioning.svg": 31754,
	"./architectural-services.svg": 93038,
	"./bathrooms.svg": 37651,
	"./bricklaying.svg": 9947,
	"./building.svg": 47538,
	"./carpentry-joinery.svg": 70149,
	"./cleaning.svg": 71539,
	"./conservatories.svg": 72655,
	"./conversions.svg": 72545,
	"./demolition.svg": 51336,
	"./designing.svg": 62068,
	"./doors-windows.svg": 49089,
	"./drainage.svg": 73161,
	"./driveways-paving.svg": 52548,
	"./electrical.svg": 63160,
	"./elevators-escalators-stairs.svg": 52302,
	"./energy-efficiency.svg": 95464,
	"./excavating-groundworks.svg": 40224,
	"./extensions.svg": 14832,
	"./fencing.svg": 84404,
	"./fireplaces-chimneys.svg": 33275,
	"./flooring.svg": 99068,
	"./garagedoors-gates.svg": 37203,
	"./gas-heating.svg": 21788,
	"./handyman-services.svg": 80835,
	"./heating-ventilation-airconditioning.svg": 39600,
	"./insulation.svg": 97896,
	"./kitchens.svg": 4841,
	"./labouring.svg": 35001,
	"./landscaping-gardening.svg": 31978,
	"./locksmith.svg": 9992,
	"./metal-structures.svg": 30002,
	"./new-build.svg": 90851,
	"./painting-decorating.svg": 803,
	"./pest-control.svg": 84798,
	"./planning.svg": 72009,
	"./plastering-rendering-dry-walling.svg": 63589,
	"./plastering.svg": 68193,
	"./plumbing.svg": 76634,
	"./property-renovation.svg": 88313,
	"./propertyrepairs-maintenance.svg": 51739,
	"./removals.svg": 10041,
	"./renewable-energy.svg": 77814,
	"./renovation.svg": 57493,
	"./retrofitting.svg": 2419,
	"./roofing.svg": 64248,
	"./satellite-tv-aerial.svg": 53487,
	"./scaffolding.svg": 56028,
	"./security-alarm-cctv.svg": 38021,
	"./shop-fitting.svg": 38436,
	"./smart-home-systems.svg": 3414,
	"./stoneworks.svg": 32521,
	"./surveying.svg": 45060,
	"./swimming-pools.svg": 5271,
	"./tiling.svg": 34907,
	"./tree-surgery.svg": 31804,
	"./waste-removal.svg": 33987,
	"./welding.svg": 81190,
	"./window-coverings.svg": 91455,
	"./windows-doors.svg": 74785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93022;